module.exports = __webpack_public_path__ + "static/media/dp1.6c1456a0.jpeg";